import { css } from 'styled-components';
import {
  getTypography, getSpacing, TypographyName, SpacingName, ThemedFunctor, rgba,
} from '@doveit/bricks';

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}

  table {
    width: 100%;
  }

  table:first-child {
    ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  }

  table:not(:first-child) {
    ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  }

  thead {
    background-color: ${rgba(theme.palettes.brand.primary, 0.9)};
    color: ${theme.palettes.neutrals.lightest};
    text-transform: capitalize;
  }

  tbody {
    tr:nth-child(odd) {
      background-color: ${theme.palettes.neutrals.lighter};
    }
  }

  th,
  td {
    ${getSpacing.padding(theme, SpacingName.SMALLER)}
    text-align: left;
  }
`;
